
export const CLEAR_ALL_DATA = 'clear_all_data';

export type SaleAction =
  | typeof CLEAR_ALL_DATA;
